
import http from '../http'
import url from './index-url'
const { get, post } = http

export default {
  getUploadToken() {
    return get(url.getUploadToken)
  },
  getCorrectionStudentlist(data) {
    return post(url.getCorrectionStudentlist, data)
  },
  getStudentSubmitlist(data) {
    return post(url.getStudentSubmitlist, data)
  },
  getCorrectionList(data) {
    return post(url.getCorrectionList, data)
  },
  postCorrectionList(data) {
    return post(url.postCorrectionList, data)
  },
  // 获取左侧小组列表
  getGroupList(data) {
    return post(url.getGroupList, data)
  },
  // 获取右侧讲次列表
  getLessonList(data) {
    return get(url.getLessonList, data)
  },
  getCountList(data) {
    return post(url.getCountList, data)
  },
  unlockLesson(data) {
    return post(url.unlockLesson, data)
  },
  workwordAnswer(arr) {
    let answerUrl = url.workwordAnswer
    arr.forEach(item => {
      answerUrl += `/${item}`
    })
    return get(answerUrl)
  },
  firstExamWordAnswer(arr) {
    let answerUrl = url.firstExamWordAnswer
    arr.forEach(item => {
      answerUrl += `/${item}`
    })
    return get(answerUrl)
  },
  // 获取右侧讲次列表
  getLessonRefreshList(data) {
    return get(url.getLessonRefreshList, data)
  },
  giveThumb(data) {
    return get(url.giveThumb, data)
  },
  addComment(data) {
    return post(url.addComment, data)
  },
  updComment(data) {
    return post(url.updComment, data)
  },
  delComment(data) {
    return get(url.delComment, data)
  },
  getComment(data) {
    return get(url.getComment, data)
  },
  unlockBeforeLesson(data) {
    return post(url.unlockBeforeLesson, data)
  },
  getPrepareInfo(data) {
    return post(url.getPrepareInfo, data)
  },
  savePrepareInfo(data) {
    return post(url.savePrepareInfo, data)
  },
  getSupMaterial(data) {
    return get(url.getSupMaterial + `/${data.classTypeId}/${data.lessonId}`)
  },
  findTeacherExplainVedio(data) {
    return get(url.teacherExplainVedio + `/${data.classTypeId}/${data.lessonId}`)
  }
}